import React from "react";
import { Routes, Route } from "react-router-dom";
import Qbank from "../../pages/Qbank/Qbank";
import PATH from "../../constants/routes";
import QbankContent from "../../pages/Qbank/QbankContent";
import QuizStatus from "../../pages/Qbank/QuizStatus/QuizStatus";
import PlayQuiz from "../../pages/Qbank/PlayQuiz/PlayQuiz";

export default function QbankRoutes() {
  return (
    <Routes>
      <Route index element={<Qbank />} />
      <Route path={PATH.QBANK_CONTENT} element={<QbankContent />} />
      <Route path={PATH.QUIZ_STATUS_ROUTE} element={<QuizStatus />} />
      <Route path={PATH.PLAY_QUIZ_ROUTE} element={<PlayQuiz />} />
    </Routes>
  );
}
